import { render, staticRenderFns } from "./FieldsModule.vue?vue&type=template&id=4f2b3608&scoped=true"
import script from "./FieldsModule.vue?vue&type=script&lang=js"
export * from "./FieldsModule.vue?vue&type=script&lang=js"
import style0 from "./FieldsModule.vue?vue&type=style&index=0&id=4f2b3608&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2b3608",
  null
  
)

export default component.exports